// @nocheck

if (typeof document !== 'undefined') {
    const original = document.createTreeWalker
    // @ts-ignore
    document.createTreeWalker = () => {
        try {
            // @ts-ignore
            return original.call(document, ...arguments)
        } catch (e) {
            const walker: TreeWalker = {
                currentNode: null as any,
                root: null as any,
                filter() {
                    return null as any
                },
                whatToShow: 0,
                firstChild() {
                    return null
                },
                lastChild() {
                    return null
                },
                nextNode() {
                    return null
                },
                nextSibling() {
                    return null
                },
                parentNode() {
                    return null
                },
                previousNode() {
                    return null
                },
                previousSibling() {
                    return null
                },
            }
            return walker
        }
    }
}
